import { RestClient } from '@/api/rest-client'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { GamificationSettings } from '@/api/model/gamification-settings'

export class GamificationSettingsClient extends RestClient<GamificationSettings> {
    collectionName = 'gamification_settings'
    parseData = GamificationSettings.fromData

    async create(data: GamificationSettings): Promise<GamificationSettings> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: GamificationSettings): Promise<GamificationSettings> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        return super.update(id, request)
    }
}
